export const LOAD_BOOTHS = 'LOAD_BOOTHS'
export const SET_FILTER = 'SET_FILTER'
export const SET_USER = 'SET_USER'
export const TOGGLE_GRID = 'TOGGLE_GRID'
export const UPDATE_BOOTHS = 'UPDATE_BOOTHS'



// WEBPACK FOOTER //
// ./src/store/actions/index.js